var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreenOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1753",
    viewBox: "0 0 9.9178247 9.9178247",
    height: "9.9178247mm",
    width: "9.9178247mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(318.67915,9.5839146)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -312.15532,0.15750434 V -3.0601711 h 3.21767",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -318.50272,-3.0601711 h 3.21767 v 3.2176755",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -318.50273,-9.4075518 3.21768,3.2176821",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -308.93764,-9.4075518 -3.21768,3.2176821",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -308.93765,-6.1898697 h -3.21767 v -3.2176966",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -315.28505,-9.4075663 v 3.2176966 h -3.21767",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -318.50273,0.15751099 3.21768,-3.21768209",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -308.93764,0.15751099 -3.21768,-3.21768209",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.35277778,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path420"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenOut);
export default __webpack_public_path__ + "static/media/fullscreen_out.aed0a88af0ae9f0dbb4e64ac434224ab.svg";
export { ForwardRef as ReactComponent };